export const COMPONENTS = {
    CONTACT: "contact",
    CHAT: "chat",
};

export const MESSAGE_TYPE = {
    MESSAGE: "message",
    SYSTEM: "system",
    REVIEW: "review",
    REPLY: "reply",
};

export const STATUS_PERSON = {
    OWNER_STATUS: "owner_status",
    CLIENT_STATUS: "client_status",
};

export const DEAL_STATUS = {
    ACTIVE: "active",
    ACCEPTED: "accepted",
    COMPLETED: "completed",
    REJECTED: "rejected",
    EXPIRED: 'expired',
    HIDDEN: 'hidden',
};
